// Redesign 2026 – čistá výpočetní logika kalkulačky předobjednávky (bez DOM).
// Vzorec převzatý ze staré kalkulačky (assets/dl-calc): úrok za výnosové období
// = částka × sazba/100 / 12 × počet měsíců období. První období bývá delší než 12 měsíců.
// Testy: tests/redesign/order-calc.test.mjs

const NBSP = ' ';

/** Nominální hodnota jednoho dluhopisu = krok částky. */
export const STEP = 50000;

/** Zaokrouhlí částku dolů na násobek STEP, minimálně jeden dluhopis. */
export function snapAmount(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n < STEP) {
    return STEP;
  }
  return Math.floor(n / STEP) * STEP;
}

/** Počet dluhopisů za částku (celé kusy). */
export function pieces(amount) {
  return Math.max(1, Math.floor(Number(amount) / STEP) || 1);
}

/** „1 dluhopis“, „2 dluhopisy“, „5 dluhopisů“. */
export function piecesLabel(count) {
  let word = 'dluhopisů';
  if (count === 1) {
    word = 'dluhopis';
  } else if (count >= 2 && count <= 4) {
    word = 'dluhopisy';
  }
  return `${count}${NBSP}${word}`;
}

/**
 * Rozpis úroku po výnosových obdobích.
 * @param {number} amount
 * @param {{months:number[], rates:number[]}|null|undefined} calc
 * @returns {{index:number, months:number, rate:number, interest:number}[]}
 */
export function schedule(amount, calc) {
  if (!calc || !Array.isArray(calc.months) || !Array.isArray(calc.rates)) {
    return [];
  }
  return calc.months.map((months, i) => ({
    index: i + 1,
    months,
    rate: calc.rates[i],
    // násobení před dělením + zaokrouhlení na haléře → bez artefaktů plovoucí čárky
    interest: Math.round((amount * calc.rates[i] * months) / 1200 * 100) / 100,
  }));
}

/** Úrok celkem a celkem vyplaceno (jistina + úrok); null bez parametrů. */
export function totals(amount, calc) {
  const rows = schedule(amount, calc);
  if (!rows.length) {
    return null;
  }
  const interest = rows.reduce((sum, row) => sum + row.interest, 0);
  return { interest, paid: amount + interest };
}

/** „74 250 Kč“ – tisíce oddělené pevnou mezerou, zaokrouhleno na koruny. */
export function formatCzk(value) {
  const rounded = String(Math.round(value));
  return `${rounded.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP)}${NBSP}Kč`;
}

/** Popisek rychlé předvolby částky: celé miliony jako „1 mil.“, jinak „150 000“ (bez Kč). */
export function presetLabel(value) {
  const n = Number(value);
  if (n >= 1000000 && n % 1000000 === 0) {
    return `${n / 1000000}${NBSP}mil.`;
  }
  return formatCzk(n).replace(`${NBSP}Kč`, '');
}

/** „8,5 %“ */
export function formatPct(rate) {
  return `${String(rate).replace('.', ',')}${NBSP}%`;
}

/** „1. rok“, „2. rok“ … (délka období v měsících se do popisku nepíše, počítá se s ní jen v úroku). */
export function periodLabel(row) {
  return `${row.index}. rok`;
}
